import React from 'react'
import { Box } from '@mui/joy';
import HeaderTwo from '../../component/header/HeaderTwo';
import Breadcrumb from '../../component/common/Breadcrumb';
import FundiPast from '../../blocks/fundi/FundiPast';


const FundiPastJob = () => {
    return (
        <>
            <Box
                sx={{
                    width: '100%',
                    padding: '0',
                    backgroundColor: '#fff',
                    boxSizing: 'border-box',

                }}
            >
                <HeaderTwo />
                {/* Home > Job > Active Job */}
                
                <Breadcrumb parent='Home' title='Job' title1='Past Job' />
                <FundiPast/>

            </Box>
        </>
    )
}

export default FundiPastJob;